import React from 'react';

import styles from './Progress.module.scss';

interface ProgressProps {
  percentage: number;
  color?: string;
}

export const Progress: React.FC<ProgressProps> = ({ percentage, color }) => (
  <div className={styles['progress-container']}>
    <div className={styles['progress-inset']}>
      <div
        className={styles['progress-bar']}
        style={
          {
            '--progress-width': `${percentage}%`,
            ...(color && { '--progress-color': color }),
          } as React.CSSProperties
        }
      />
    </div>
  </div>
);
